import { render, staticRenderFns } from "./review-list-manage.vue?vue&type=template&id=1f12864d"
import script from "./review-list-manage.vue?vue&type=script&lang=ts"
export * from "./review-list-manage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports